export default __webpack_public_path__ + "static/media/README.ad98902a.md";